import { PricingRequestDTO } from '../../frameworks_drivers/dtos/PricingRequestDTO';
import { StoreObject } from '../../frameworks_drivers/redux/reducers/onboardingInformation';
import { MiscStoreData } from '../../frameworks_drivers/redux/reducers/miscellaneous/miscSlice';
import { ABTesting } from '../../frameworks_drivers/redux/reducers/abTest/abTesting';
import { MetaItem } from '../../clients';
import { PricingPayloadBuilder } from './PricingPayloadBuilder';
import { RadioOptionKeys } from '../../tools/RadioOptionMapper';

export class PricingPayloadBuilderImpl implements PricingPayloadBuilder {
  buildPayload(
    onboardingInfo: StoreObject,
    misc: MiscStoreData,
    abTesting: ABTesting,
    forceFullPrice: boolean = false
  ): PricingRequestDTO {
    return {
      numberOfApartments: onboardingInfo.numberOfApartments || 0,
      heatingCostsInvoice: onboardingInfo.heatingCostsInvoice,
      centralHotWaterDelivery:
        onboardingInfo.centralHotWaterDelivery === RadioOptionKeys.HotWaterDeliveryCentral.Yes,
      heatingType: onboardingInfo.heatingType,
      heatingSources: onboardingInfo.heatingSources,
      email: onboardingInfo.contactDetails.email,
      meta: this.buildMetaArray(abTesting),
      discountCode:
        !forceFullPrice && misc && misc.referralDiscountCode ? misc.referralDiscountCode : undefined
    };
  }

  // TODO: Refactor and extract into seperate Components
  private buildMetaArray(abTesting: ABTesting): MetaItem[] {
    const names: Array<keyof ABTesting> = ['pricing', 'stockShortage'];
    const metaArr: MetaItem[] = names.map((name) => ({
      type: 'ab_test',
      name: name,
      value: abTesting[name].scenario
    }));

    metaArr.map((item) => {
      if (item.name === 'pricing' && item.value === null) {
        item.value = 'default';
      }
      return item;
    });

    return [...metaArr, ...this.extractQueryParameters(window.location.search)];
  }

  // TODO: Refactor and extract into seperate Components
  private extractQueryParameters(search: string): MetaItem[] {
    const params = new URLSearchParams(search);
    const queryParameters: MetaItem[] = [];
    params.forEach((value, key) => {
      queryParameters.push({ type: 'query_parameter', name: key, value });
    });
    return queryParameters;
  }
}
